import {
  doDELETERequest,
  doGETRequest,
  doPATCHRequest,
  doPOSTRequest,
  doPUTRequest
} from "./Api";

class AdminBasketApi {
  
  public static async createOrUpdate(data: any) {
    if(data.id) {
      return this.update(data);
    }
    return this.create(data);
  }
  
  public static async create(data: any) {
    const relativePath = "/admin/baskets";
    var response = await doPOSTRequest(relativePath, data);
    return response;
  }

  public static async update(data: any) {
    const relativePath = "/admin/baskets";
    var response = await doPUTRequest(relativePath, data);
    return response;
  }

  public static async delete(id: any, data: any) {
    const relativePath = "/admin/baskets/"+id+"/delete";
    var response = await doPATCHRequest(relativePath, data);
    return response;
  }
  
  public static async listAll() {
    const relativePath = "/admin/baskets";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAllIdsByBuyerId(id: any) {
    const relativePath = "/admin/basket/"+id;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async applyToOrderWithBody(applyToOrder:any) {
    const relativePath = "/admin/baskets/apply-to-order";
    var response = await doPOSTRequest(relativePath, applyToOrder);
    return response;
  }
}

export default AdminBasketApi;